import axios from 'axios'

const baseUrl = process.env.API_BASE_URL

export type AccountData = {
  code: string
  username: string
}

export const signupValidation = ({ username, code }: AccountData) =>
  axios.post(`${baseUrl}/signup-validation`, {
    username: username,
    code: code,
  })
